import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X, FileText } from "lucide-react";
import { COMPANY } from "@/lib/site-data";

export default function FloatingActions() {
    const [showExit, setShowExit] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (dismissed) return;
        let shown = false;
        const onLeave = (e) => {
            if (shown) return;
            if (e.clientY < 5 && window.scrollY > 200) {
                shown = true;
                setShowExit(true);
            }
        };
        document.addEventListener("mouseout", onLeave);
        return () => document.removeEventListener("mouseout", onLeave);
    }, [dismissed]);

    return (
        <>
            {/* WhatsApp floating button */}
            <a
                href={`https://wa.me/${COMPANY.whatsapp}?text=Hi%20Vibhuti%20Logistics%2C%20I%27d%20like%20to%20discuss%20a%20logistics%20requirement.`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="floating-whatsapp"
                aria-label="Chat on WhatsApp"
                className="fixed bottom-20 md:bottom-6 left-6 z-40 inline-flex items-center justify-center w-14 h-14 bg-[#25D366] text-white shadow-[4px_4px_0px_#101A2C] hover:-translate-y-0.5 transition-transform"
            >
                <MessageCircle className="h-7 w-7" strokeWidth={1.75} />
            </a>

            {/* Sticky 'Get Quote' pill — above the Emergent badge, compact, doesn't overlap content tabs */}
            <Link
                to="/contact"
                data-testid="sticky-quote-cta"
                className="fixed bottom-[72px] right-6 z-30 hidden md:inline-flex items-center gap-2 px-5 py-3 bg-[#28406A] text-white font-display uppercase text-xs tracking-widest font-semibold hover:bg-[#101A2C] transition-colors"
                style={{ boxShadow: "3px 3px 0px #F4A000" }}
            >
                <FileText className="h-4 w-4" strokeWidth={1.75} />
                Get a Logistics Quote
            </Link>

            {/* Exit intent popup */}
            {showExit && !dismissed && (
                <div
                    className="fixed inset-0 z-[60] bg-[#101A2C]/80 flex items-end md:items-center justify-center p-4"
                    data-testid="exit-intent-overlay"
                    onClick={() => setDismissed(true)}
                >
                    <div
                        className="relative bg-white max-w-lg w-full p-8 border-t-4 border-[#F4A000]"
                        onClick={(e) => e.stopPropagation()}
                        data-testid="exit-intent-popup"
                    >
                        <button
                            onClick={() => setDismissed(true)}
                            className="absolute top-3 right-3 p-1 text-[#4B6390] hover:text-[#28406A]"
                            data-testid="exit-intent-close"
                            aria-label="Close"
                        >
                            <X className="h-5 w-5" />
                        </button>
                        <p className="overline mb-3">Free 30-min assessment</p>
                        <h3 className="heading-h3 text-[#101A2C] mb-3">
                            Need help optimizing your supply chain?
                        </h3>
                        <p className="text-sm text-[#4B6390] mb-6">
                            Book a complimentary logistics assessment with our supply-chain experts. We'll map your current spend, surface inefficiencies and propose a 3PL/4PL roadmap — no obligation.
                        </p>
                        <Link
                            to="/contact"
                            onClick={() => setDismissed(true)}
                            data-testid="exit-intent-cta"
                            className="btn-primary"
                        >
                            Schedule My Assessment
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
}
